"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NativeFcmSendIntegrationConfig = void 0;
var send_integration_configuration_1 = require("./send-integration-configuration");
var send_integrations_1 = require("../../interfaces/send-integrations");
var class_validator_1 = require("class-validator");
var is_not_empty_string_1 = require("../../class-validators/is-not-empty-string");
var native_fcm_send_integration_config_builder_1 = require("../../builders/native-fcm-send-integration-config-builder");
var class_transformer_1 = require("class-transformer");
var case_insensitive_ingest_1 = require("../../class-transformers/case-insensitive-ingest");
var hydrateBuilderFromKwArgs = function (config) {
    return NativeFcmSendIntegrationConfig.Builder.setIsActive(config.isActive)
        .setApiVersion(config.apiVersion)
        .setServerApiKey(config.serverApiKey)
        .setSenderId(config.senderId)
        .setServiceAccountJsonFileUrl(config.serviceAccountJsonFileUrl)
        .setNotificationAccentColor(config.notificationAccentColor)
        .setUseImageForIconWhenPresent(config.useImageForIconWhenPresent);
};
var NativeFcmSendIntegrationConfig = (function (_super) {
    __extends(NativeFcmSendIntegrationConfig, _super);
    function NativeFcmSendIntegrationConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(NativeFcmSendIntegrationConfig, "Builder", {
        get: function () {
            return new native_fcm_send_integration_config_builder_1.NativeFcmSendIntegrationConfigBuilder();
        },
        enumerable: false,
        configurable: true
    });
    NativeFcmSendIntegrationConfig.buildActiveLegacyConfiguration = function (config) {
        return hydrateBuilderFromKwArgs(__assign(__assign({}, config), { isActive: true, apiVersion: send_integrations_1.FcmSendIntegrationApiVersion.LEGACY })).build({ groups: [send_integrations_1.FcmSendIntegrationApiVersion.LEGACY] });
    };
    NativeFcmSendIntegrationConfig.buildActiveV1Configuration = function (config) {
        return hydrateBuilderFromKwArgs(__assign(__assign({}, config), { isActive: true, apiVersion: send_integrations_1.FcmSendIntegrationApiVersion.V1 })).build({ groups: [send_integrations_1.FcmSendIntegrationApiVersion.V1] });
    };
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'api_version' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsEnum)(send_integrations_1.FcmSendIntegrationApiVersion, {
            groups: [send_integrations_1.FcmSendIntegrationApiVersion.LEGACY, send_integrations_1.FcmSendIntegrationApiVersion.V1],
        }),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", String)
    ], NativeFcmSendIntegrationConfig.prototype, "apiVersion", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'sender_id' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, is_not_empty_string_1.IsNotEmptyString)({ groups: [send_integrations_1.FcmSendIntegrationApiVersion.LEGACY, send_integrations_1.FcmSendIntegrationApiVersion.V1] }),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", String)
    ], NativeFcmSendIntegrationConfig.prototype, "senderId", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'server_api_key' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, is_not_empty_string_1.IsNotEmptyString)({ groups: [send_integrations_1.FcmSendIntegrationApiVersion.LEGACY] }),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", String)
    ], NativeFcmSendIntegrationConfig.prototype, "serverApiKey", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'service_account_json_file_url' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, is_not_empty_string_1.IsNotEmptyString)({ groups: [send_integrations_1.FcmSendIntegrationApiVersion.V1] }),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", String)
    ], NativeFcmSendIntegrationConfig.prototype, "serviceAccountJsonFileUrl", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'notification_accent_color' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, is_not_empty_string_1.IsNotEmptyString)({ groups: [send_integrations_1.FcmSendIntegrationApiVersion.LEGACY, send_integrations_1.FcmSendIntegrationApiVersion.V1] }),
        (0, class_validator_1.IsOptional)({ groups: [send_integrations_1.FcmSendIntegrationApiVersion.LEGACY, send_integrations_1.FcmSendIntegrationApiVersion.V1] }),
        __metadata("design:type", String)
    ], NativeFcmSendIntegrationConfig.prototype, "notificationAccentColor", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'use_image_for_icon_when_present' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsBoolean)({ groups: [send_integrations_1.FcmSendIntegrationApiVersion.LEGACY, send_integrations_1.FcmSendIntegrationApiVersion.V1] }),
        (0, class_validator_1.IsOptional)({ groups: [send_integrations_1.FcmSendIntegrationApiVersion.LEGACY, send_integrations_1.FcmSendIntegrationApiVersion.V1] }),
        __metadata("design:type", Boolean)
    ], NativeFcmSendIntegrationConfig.prototype, "useImageForIconWhenPresent", void 0);
    return NativeFcmSendIntegrationConfig;
}(send_integration_configuration_1.SendIntegrationConfiguration));
exports.NativeFcmSendIntegrationConfig = NativeFcmSendIntegrationConfig;
//# sourceMappingURL=native-fcm-send-integration-config.js.map